var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v(" OUT-PATIENT CARE ")]),_c('h4',[_vm._v(" Medical services/procedures to be rendered to a non-hospitalized HMI member under the direction of an HMI Physician-In-Charge at his designated MSU or at any HMI Clinic. ")])])
}]

export { render, staticRenderFns }